import type { AdCampaign } from "@/types";
import { useLanguage } from "@/hooks/useLanguage";

/**
 * PR-22 — Non-intrusive sponsor badge used during critical plays.
 * Max 32px tall, lives above the pitch — never covers the field.
 */
export function MinimalSponsorBadge({ campaign }: { campaign: AdCampaign | null }) {
  const { t } = useLanguage();
  if (!campaign) return null;
  return (
    <div
      className="pointer-events-none flex h-8 max-w-full items-center gap-1.5 rounded-full border border-border bg-[oklch(0.06_0.005_260)] px-3 text-[13px] font-bold text-[oklch(1_0_0)] shadow-lg"
      style={{ maxHeight: 32 }}
      aria-label={t("sponsor_badge_aria", { sponsor: campaign.sponsor_name })}
    >
      <span className="text-[oklch(1_0_0)]">{t("sponsor_badge_sponsored_by")}</span>
      <span className="font-black text-[oklch(1_0_0)]">{campaign.sponsor_name}</span>
    </div>
  );
}